// extracted by mini-css-extract-plugin
module.exports = {"SuccessContainer":"PSEResponse_SuccessContainer__1eUls","Logo":"PSEResponse_Logo__1rNDK","TryAgain":"PSEResponse_TryAgain__2QZl3","Blue":"PSEResponse_Blue__NxcjM"};